(() => {
  if (window.__lmcdOfferHouseScript) return;
  window.__lmcdOfferHouseScript = true;

  const initializeRoot = (root) => {
    if (root.dataset.lmcdHouseReady === 'true') return;
    root.dataset.lmcdHouseReady = 'true';
    const cleanup = [];
    const listen = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      cleanup.push(() => target.removeEventListener?.(event, handler, options));
    };
    const menuTrigger = root.querySelector('[data-lmcd-house-menu-trigger]');
    const mobileMenu = root.querySelector('[data-lmcd-house-mobile-menu]');
    const form = root.querySelector('[data-lmcd-house-primary-form]');
    const stickyCta = root.querySelector('[data-lmcd-house-sticky-cta]');
    const stickySubmit = root.querySelector('[data-lmcd-house-sticky-submit]');
    const footer = root.querySelector('[data-lmcd-house-footer]');

    if (menuTrigger && mobileMenu) {
      const setMenuOpen = (open) => {
        mobileMenu.hidden = !open;
        menuTrigger.setAttribute('aria-expanded', String(open));
        menuTrigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      };
      listen(menuTrigger, 'click', () => setMenuOpen(mobileMenu.hidden));
      listen(document, 'keydown', (event) => {
        if (event.key === 'Escape') setMenuOpen(false);
      });
    }

    if (form && stickyCta) {
      const updateSticky = () => {
        const pastPurchase = form.getBoundingClientRect().bottom <= 0;
        const nearFooter = footer && footer.getBoundingClientRect().top <= window.innerHeight + 100;
        const nearDocumentEnd = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 100;
        stickyCta.hidden = !pastPurchase || Boolean(nearFooter) || nearDocumentEnd;
      };
      updateSticky();
      listen(window, 'scroll', updateSticky, { passive: true });
      listen(window, 'resize', updateSticky);
    }

    if (form && stickySubmit && !stickySubmit.disabled) {
      listen(stickySubmit, 'click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.querySelector?.('[type="submit"]')?.click();
      });
    }

    root.__lmcdHouseTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      delete root.dataset.lmcdHouseReady;
    };
  };

  const initializeAll = () => document.querySelectorAll('[data-lmcd-house-offer]').forEach(initializeRoot);
  const destroyWithin = (node) => {
    if (node.matches?.('[data-lmcd-house-offer]')) node.__lmcdHouseTeardown?.();
    node.querySelectorAll?.('[data-lmcd-house-offer]').forEach((root) => root.__lmcdHouseTeardown?.());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
